export const AGREEMENT_MONTH_PRESETS = [1, 2, 3, 4, 5, 6, 9, 12, 18, 24, 36];

export const monthsToDurationDays = (months) => Math.max(1, parseInt(months, 10) || 1) * 30;

export const durationDaysToMonths = (days) => {
  const d = parseInt(days, 10);
  if (!d || d <= 0) return 1;
  if (d >= 360) return 12;
  if (d <= 31) return 1;
  return Math.max(1, Math.round(d / 30));
};

export const formatAgreementMonths = (months) => {
  const m = parseInt(months, 10);
  if (!m || m <= 0) return "—";
  return m === 1 ? "1 month" : `${m} months`;
};

export const buildPricePayload = (packageID, price) => {
  const agreementMonths = parseInt(price.agreementMonths, 10) || 1;
  return {
    PackageID: packageID,
    PriceCurrency: price.currency.value,
    Price: parseFloat(price.price) || 0,
    ActualPrice: parseFloat(price.actualPrice) || 0,
    AgreementMonths: agreementMonths,
    Duration: monthsToDurationDays(agreementMonths),
    Country: price.country || "",
  };
};

export const isSamePriceTier = (a, b) =>
  a.currency?.value === b.currency?.value &&
  (a.country || "") === (b.country || "") &&
  parseInt(a.agreementMonths, 10) === parseInt(b.agreementMonths, 10);
